import axios from 'axios';

export const isAxiosAbortError = (error: unknown): boolean => {
  return (
    axios.isCancel(error) ||
    (typeof error === 'object' &&
      error !== null &&
      'code' in error &&
      (error as { code?: string }).code === 'ERR_CANCELED')
  );
};
